import { ReactNode } from 'react';

import { ApolloProvider as ApolloClientProvider } from '@apollo/client';

import { apolloClient } from 'config';

interface ApolloProviderProps {
  children: ReactNode;
}

export function ApolloProvider({ children }: ApolloProviderProps): JSX.Element {
  return (
    <ApolloClientProvider client={apolloClient}>
      {children}
    </ApolloClientProvider>
  );
}
